"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var locales_1 = require("../locales");
var index_1 = require("../index");
var Script = function (_a) {
    var appId = _a.appId, pageId = _a.pageId, cookie = _a.cookie, nonce = _a.nonce, language = _a.language, features = _a.features;
    var loginScript = (0, react_1.useRef)(null);
    var chatScript = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (typeof window !== "undefined" &&
            (features.includes(index_1.Features.LOGIN_BUTTON) ||
                features.includes(index_1.Features.CHAT_PLUGIN))) {
            var fjs = document.getElementsByTagName("script")[0];
            if (appId && loginScript.current) {
                loginScript.current.async = true;
                loginScript.current.defer = true;
                loginScript.current.crossOrigin = "anonymous";
                loginScript.current.nonce = nonce;
                loginScript.current.src = "https://connect.facebook.net/".concat(language || (0, locales_1.getNavigatorLanguage)(), "/sdk.js");
                (_a = fjs === null || fjs === void 0 ? void 0 : fjs.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(loginScript.current, fjs);
            }
            if (pageId && chatScript.current) {
                chatScript.current.async = true;
                chatScript.current.defer = true;
                chatScript.current.crossOrigin = "anonymous";
                chatScript.current.nonce = nonce;
                chatScript.current.src = "https://connect.facebook.net/".concat(language || (0, locales_1.getNavigatorLanguage)(), "/sdk/xfbml.customerchat.js");
                (_b = fjs === null || fjs === void 0 ? void 0 : fjs.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(chatScript.current, fjs);
            }
        }
        else {
            console.error("props 'appId' is required to initiate Facebook SDK!");
        }
    }, [appId, pageId, cookie, language, features, nonce]);
    (0, react_1.useEffect)(function () {
        if ((typeof window !== "undefined" && loginScript.current) ||
            chatScript.current)
            // Define the FB async init function
            window.fbAsyncInit = function () {
                // Handle login status and login/logout events
                window.FB.init({
                    appId: appId,
                    cookie: cookie,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: "v16.0"
                });
            };
    }, [loginScript, chatScript, appId, cookie]);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        appId && react_1["default"].createElement("script", { ref: loginScript }),
        pageId && react_1["default"].createElement("script", { ref: chatScript }),
        react_1["default"].createElement("div", { id: "fb-root" })));
};
exports["default"] = Script;
//# sourceMappingURL=Script.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tusken-s/facebook-tools/dist/cjs/components/Script.js
// module id = 219
// module chunks = 168707334958949